import { useTranslation } from 'react-i18next';
import AttentionIcon from '@/icons/attention.svg?react';
import Button from './Button';

export const COARevenueAccountsInfoBlock = () => {
  const { t } = useTranslation();
  return (
    <div className='rounded-lg border p-2'>
      <div className='flex-items-center mb-2 font-semibold'>
        <AttentionIcon className='mr-2 shrink-0' />
        {t('Information')}
      </div>
      <div className='mb-4 text-gray-700'>
        {t(
          'Revenue accounts are used to record sales and income from the sale of goods or services.'
        )}
      </div>
      <div className='mb-4 text-gray-700'>
        {t('We use the default values recommended by DATEV.')}
      </div>
      <Button styling='naked-blue' className='!font-semibold'>
        {t('Download list as XLSX')}
      </Button>
    </div>
  );
};
